module.exports = __webpack_public_path__ + "static/media/purple_phat.6f4e232d.png";